import React, { forwardRef } from "react";
import { TkButtonProps } from "../../../type/componentsType/TkButton";
import { Button, ButtonProps } from "@mui/material";
import "./_style.scss";
import { useThrottled } from "../../../utils/useTools";

/**
 * ボタン部品
 * TkButtonコンポーネントは、MUIのButtonコンポーネントを拡張したものです。
 * @param {TkButtonProps} props - TkButtonコンポーネントのプロパティ
 * @param {ReactNode} props.children - TkButtonコンポーネントの子要素
 * @param {string} [props.variant="contained"] - TkButtonコンポーネントのvariantプロパティ
 * @param {string} [props.size="small"] - TkButtonコンポーネントのsizeプロパティ
 * @returns TkButton ボタン部品
 */
const TkButton = forwardRef<HTMLButtonElement, TkButtonProps & ButtonProps>(
  (props, ref) => {
    const {
      children,
      variant = "contained",
      size = "small",
      href,
      ml,
      mr,
      onClick,
      delay = 1000,
      className,
      ...rest
    } = props;

    const throttledOnClick = useThrottled(delay, onClick);
    const useHandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick && throttledOnClick(event);
    };

    return (
      <Button
        {...rest}
        data-testid="tkButtonForTest"
        className={`tkBotton ${ml ? "tkBottonMl" : ""} ${
          mr ? "tkBottonMr" : ""
        } ${className}`}
        variant={variant}
        size={size}
        href={href}
        ref={ref}
        onClick={useHandleClick}
      >
        {children}
      </Button>
    );
  }
);

export default TkButton;
